// extracted by mini-css-extract-plugin
export default {"container":"chart__container___KpBIC","numberChartCentered":"chart__numberChartCentered___LBEV2"};